import { number } from 'prop-types';
import React, { PureComponent } from 'react';
import { Image } from 'react-native';

import { C } from '../../common';
import onElTiempoDomain from '../../common/onElTiempoDomain';
import { Consumer } from '../../context';
import { LAYOUT, THEME } from '../../reactor/common';
import { Motion, ProgressBar, Text } from '../../reactor/components';
import styles from './Loading.style';

const { MINUBE } = C;
const { COLOR, MOTION: { DURATION } } = THEME;

class Loading extends PureComponent {
  static propTypes = {
    progress: number,
  };

  static defaultProps = {
    progress: 0,
  };

  render() {
    const { props: { progress } } = this;
    const { LANDSCAPE, H: height, W: width } = LAYOUT.VIEWPORT;
    const loaded = progress === 1;

    return (
      <Consumer>
        { ({ dataSource: { logo = MINUBE.LOGO_GREY, primary, onExternalDomain } = {}, l10n }) => (
          <Motion
            delay={loaded ? 1500 : 0}
            duration={DURATION / 2}
            style={[styles.container, { height, width }]}
            timeline={[{ property: 'translateY', value: loaded ? -height : 0 }]}
          >
            { !onElTiempoDomain() && (
              <Motion timeline={[{ property: 'translateY', value: loaded ? -height : 0 }]}>
                { onExternalDomain === false && (
                  <Image source={{ uri: logo }} resizeMode="contain" style={styles.logo} />
                )}
              </Motion>
            )}
            <ProgressBar progress={progress} style={styles.progressBar} color={primary || COLOR.PRIMARY} />
            <Motion
              delay={loaded ? 500 : 0}
              duration={loaded ? 750 : 0}
              style={[styles.background, { backgroundColor: primary || COLOR.PRIMARY }]}
              timeline={[{ property: 'height', value: loaded ? height : 0 }]}
            >
              <Motion delay={250} preset="pop" visible={loaded}>
                <Text headline level={LANDSCAPE ? 1 : 3} style={styles.text}>
                  {l10n.LOADING}
                </Text>
              </Motion>
            </Motion>
          </Motion>
        ) }
      </Consumer>
    );
  }
}

export default Loading;
